// #standard page 
import React, { Component } from 'react';

//#table
import GenericTable from '../../components/GenericTable';
import { dateFormat, currencyFormat } from '../../helpers/formatter';

//#form
import { Card, CardBody } from 'reactstrap';

//#other
import moment from 'moment';
import { fetchJSON } from '../../helpers/api';

const dateLabelFormat = (cell, row) => {
    if (row.serialNo) {
        if (row.serialNo.toLowerCase().startsWith('total')) {
            return row.serialNo;
        }
    }
    return dateFormat(cell);
}


const columns = [
    {
        dataField: 'keyField',
        searchable: false,
        hidden: true
    },
    {
        dataField: 'serialNo',
        searchable: false,
        hidden: true
    },
    {
        dataField: 'leaseNo',
        searchable: false,
        hidden: true
    },
    {
        dataField: 'transactionDate',
        text: 'Date',
        formatter: dateLabelFormat
    },
    {
        dataField: 'transactionType',
        text: 'Transaction Type',
    },
    {
        dataField: 'transactionRef',
        text: 'Ref',
    },
    {
        dataField: 'description',
        text: 'Description',
    },
    {
        dataField: 'dr',
        text: 'Dr',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'cr',
        text: 'Cr',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'balance',
        text: 'Outstanding Bal',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    }
];



class TransactionDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
            loading: true,
            refresh: false
        };
    }

    componentDidMount = () => {
        //console.log(this.props);
        this.loadTransactionDetails(this.props.serialNo, this.props.leaseNo);
    };


    componentDidUpdate(prevProps) {
        // refresh data after refresh button clicked 
        // must check props have changed (this.props.refresh !== prevProps.refresh) to avoid infinite loop
        if (this.props.refresh && this.props.refresh !== prevProps.refresh) {
            this.setState({
                data: [],
                fromDate: this.props.fromDate,
                toDate: this.props.toDate,
                loading: true,
                refresh: true
            });

            this.loadTransactionDetails(this.props.serialNo, this.props.leaseNo);
        }
    }


    async loadTransactionDetails(serialNo, leaseNo) {
        let fromDate = moment(this.state.fromDate, moment.ISO_8601).format("DD-MMM-YYYY");
        let toDate = moment(this.state.toDate, moment.ISO_8601).format("DD-MMM-YYYY");
        let url = `/portal/LeaseAccount/GetTransactionDetails?serialNo=${serialNo}&leaseNo=${leaseNo}&fromDate=${fromDate}&toDate=${toDate}`;
        let response = await fetchJSON(url);
        this.setState({
            data: response.data,
            loading: response.loading,
            refresh: false
        });
    }


    render() {

        const rowClasses = (row) => {
            if (row.serialNo) {
                if (row.serialNo.toLowerCase().startsWith('total')) {
                    return 'font-weight-bold';
                }
            }
        };


        return (
            <React.Fragment>
                <Card className="expand-row">
                    <CardBody>
                        <span className="h5">Transaction Serial No. {this.props.serialNo} (Ref {this.props.leaseNo})</span>
                        <GenericTable
                            columns={columns}
                            data={this.state.data}
                            keyField='keyField'
                            loading={this.state.loading}
                            rowClasses={rowClasses}
                            noSearch
                            noPagination
                        />
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
};


export default TransactionDetails;